import { Box, CircularProgress, SxProps, Theme } from '@mui/material';

interface Props {
  sx?: SxProps<Theme>;
}

const LoadingScreen = ({ sx }: Props) => {
  return (
    <Box
      sx={[
        {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          flexGrow: 1,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <CircularProgress size={32} />
    </Box>
  );
};

export default LoadingScreen;
